import { createColumnHelper } from "@tanstack/react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

import { tableColumns } from "../../constants";
import {
  UTCToDateFormat,
  UTCToDateTimeFormatWithoutSeconds,
} from "../../../../shared";

const columnHelper = createColumnHelper();

//Static headers for data table
export const individualStorePerformanceColumns = (
  isBrandInboxActive,
  allConversationModal
) => [
  columnHelper.accessor("name", {
    header: () => "NAME",
  }),
  columnHelper.accessor("externalOrderId", {
    header: () => "ORDER NUMBER",
  }),
  columnHelper.accessor("orderDate", {
    header: () => "ORDER DATE",
    cell: (row) => row.getValue() && UTCToDateFormat(row.getValue()),
  }),
  columnHelper.accessor("surveyCompletionDate", {
    header: () => "SURVEY COMPLETION DATE",
    minSize: tableColumns.SIZE_200,
    cell: ({ row }) => {
      const userResponseData = row.original;
      return (
        userResponseData.surveyCompletionDate &&
        UTCToDateTimeFormatWithoutSeconds(
          userResponseData.surveyCompletionDate
        )
      );
    },
  }),
  columnHelper.accessor("averageGuestTransaction", {
    header: (
      <span className="text-secondary">AVERAGE TRANSACTION RATING</span>
    ),
    enableSorting: false,
  }),
  columnHelper.accessor("averageGuestSentiment", {
    header: <span className="text-secondary">AVERAGE SENTIMENT RATING</span>,
    enableSorting: false,
  }),
  columnHelper.accessor("surveysCompleted", {
    header: () => "SURVEYS COMPLETED",
    enableSorting: false,
  }),

  ...(isBrandInboxActive
    ? [
        columnHelper.accessor("action", {
          header: () => "INTERNAL NOTES",
          enableSorting: false,
          cell: ({
            row: {
              original: { name, customerId },
            },
          }) => {
            return (
              <div className="text-center p-0 m-0">
                <FontAwesomeIcon
                  role="button"
                  icon={faEye}
                  name="view internal notes"
                  onClick={(e) => allConversationModal(e, customerId, name)}
                />
              </div>
            );
          },
        }),
      ]
    : []),
];
